<template>
	<div :class="[companyClass, canScroll]" v-loading="pageLoading" element-loading-text="Loading..."
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="page-table flex column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<div class="page-header">
				<h1 class="pageTitle">Compliance Transactions</h1>
				<h4>transactions list </h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>settings</el-breadcrumb-item>
					<el-breadcrumb-item>compliance</el-breadcrumb-item>
					<el-breadcrumb-item>transactions</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="mt-0">
				<div style="float: right;">
					<el-button v-show="showDelete" type="danger" icon="el-icon-delete"
						@click="deleteSelectedPrompt"></el-button>
					<el-button v-show="!showDelete" type="warning" icon="el-icon-search"
						@click="searchFormVisible = true"></el-button>
				</div>
			</div>

			<div class="toolbar-box flex">
				<div class="search-box box grow">
					<div><i class="mdi mdi-magnify"></i></div>
					<input v-model="searchParameters.referenceNumber" placeholder="Search..."
						@keyup.enter="searchTransaction" @keyup.tab="searchTransaction" />
				</div>
				<div class="pagination-box animated fadeInRight">
					<div class="select-box">
						<el-select v-model="paginationInfo.pageSize" placeholder="Rows per page" size="mini"
							@change="refreshTransactions">
							<el-option value="10" label="10"></el-option>
							<el-option value="15" label="15"></el-option>
							<el-option value="20" label="20"></el-option>
							<el-option value="30" label="30"></el-option>
							<el-option value="50" label="50"></el-option>
							<el-option value="100" label="100"></el-option>
						</el-select>
					</div>
					<div class="label">/page</div>
				</div>
				<div class="csv-box animated fadeInRight">
					<button @click="downloadData">download csv ({{ total }})</button>
				</div>
			</div>

			<resize-observer @notify="handleResize" />

			<div class="table-box card-base card-shadow--medium box grow" id="table-wrapper" v-loading="!asyncComponent">
				<div :style="{ 'width': width + 'px' }">
					<!-- v2-table -->
					<component :is="asyncComponent" ref="table" :data="list" :height="height" :border="false" :total="total"
						:lazy-load="false" :loading="loading" class="styled" :class="{ 'mobile': isMobile }"
						@page-change="handlePageChange" :pagination-info="paginationInfo"
						:default-sort="{ prop: sortingProp, order: sortingOrder }" @sort-change="handleSortChange"
						@select-change="handleSelectChange" :show-summary="showSummary" :shown-pagination="shownPagination"
						:row-class-name="getRowClassName">
						<v2-table-column type="selection" width="45"></v2-table-column>
						<v2-table-column label="Reference Number" prop="referenceNumber" sortable width="150" align="left"
							:fixed="isMobile ? '' : 'left'"><span slot="label">runner</span></v2-table-column>
						<v2-table-column label="Sender" prop="senderName" sortable width="150" align="left"
							:fixed="isMobile ? '' : 'left'"><span slot="label">runner</span></v2-table-column>
						<v2-table-column label="Receiver" prop="receiverName" sortable width="150" align="left"
							:fixed="isMobile ? '' : 'left'"></v2-table-column>
						<v2-table-column label="Status" prop="transactionStatusStr" width="150" align="center" sortable>
							<template slot-scope="scope">
								<div class="custom-display-date">{{ scope.transactionStatusStr }}</div>
							</template>
						</v2-table-column>

						<v2-table-column label="Currency" prop="receiverCurrencySymbol" width="150" align="center"
							sortable></v2-table-column>
						<v2-table-column label="Amount" prop="receiverAmountStr" width="150" align="left"
							sortable></v2-table-column>
						<v2-table-column label="Service Type" prop="serviceName" width="150" align="left"
							sortable></v2-table-column>
						<v2-table-column label="Service Provider" prop="serviceProviderName" width="150" align="left"
							sortable></v2-table-column>
						<v2-table-column label="Sender Country" prop="countryName" width="150" align="left"
							sortable></v2-table-column>
						<v2-table-column label="Receiver Country" prop="receiverCountryName" width="150" align="left"
							sortable></v2-table-column>
						<v2-table-column label="Time" prop="createdAtStr" sortable width="150"
							align="center"></v2-table-column>
						<v2-table-column label="Date" prop="createdOnStr" sortable width="150" align="center"
							:fixed="isMobile ? '' : 'right'"></v2-table-column>


						<v2-table-column label="Action" width="70" :fixed="isMobile ? '' : 'right'">
							<template slot-scope="row">
								<div class="custom-action-row">
									<el-button @click="print(row)"><i class="mdi mdi-eye"></i></el-button>
								</div>
							</template>
						</v2-table-column>
					</component><!-- v2-table -->

				</div>
			</div>

			<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" :before-close="handleClose"
				v-loading="isUpdatingTransfastReceipient" :element-loading-text="updatingTransfastReceipientText"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<div v-if="receiverInfoDialogVisible">
					<div v-if="isTransfastTransaction">
						<el-row :gutter="20">
							<el-col :span="8">
								<span>Receiver's Country</span>
								<el-select v-model="transFastPayoutRequest.receiverCountryIsoCode"
									placeholder="Receiver's Country" class="mb-10" style="width:100%" name="receivercountry"
									v-validate="'required'" data-vv-as="receiver's country" @change="tfCountryChanged">
									<el-option v-for="tfCountry in countries" :key="tfCountry.code" :label="tfCountry.name"
										:value="tfCountry.code">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receivercountry') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Receiver's State</span>
								<el-select v-model="transFastPayoutRequest.receiverStateId" placeholder="Receiver's State"
									class="mb-10" style="width:100%" name="receiverstate" v-validate="'required'"
									data-vv-as="receiver's state" @change="tfStateChanged">
									<el-option v-for="tfState in transfastStates" :key="tfState.id" :label="tfState.name"
										:value="tfState.id">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receiverstate') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Receiver's City</span>
								<el-select v-model="transFastPayoutRequest.receiverCityId" placeholder="Receiver's City"
									class="mb-10" style="width:100%" name="receivercity" v-validate="'required'"
									data-vv-as="receiver's city">
									<el-option v-for="tfCity in transfastCities" :key="tfCity.id" :label="tfCity.name"
										:value="tfCity.id">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receivercity') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="8">
								<span>Transaction Reference</span>
								<el-input placeholder="Transaction Reference" v-model="selectedTransaction.referenceNumber"
									name="tfpin" v-validate="'required'" :readonly="true"
									data-vv-as="transaction reference"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('tfpin') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Receiver's Document Type</span>
								<el-select v-model="transFastPayoutRequest.idType" placeholder="Receiver's Document Type"
									class="mb-10" style="width:100%" name="receiverdocType" v-validate="'required'"
									data-vv-as="receiver's document type">
									<el-option v-for="tfIdType in transfastReceiverIdTypes" :key="tfIdType.id"
										:label="tfIdType.name" :value="tfIdType.id">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receiverdocType') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Document number</span>
								<el-input placeholder="Receiver's Document Number" v-model="transFastPayoutRequest.idNumber"
									name="receiverdocnumber" v-validate="'required'"
									data-vv-as="receiver's document number"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receiverdocnumber') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="8">
								<span>Document Issued By</span>
								<el-select v-model="transFastPayoutRequest.idIssuedBy" placeholder="Document Issued By"
									class="mb-10" style="width:100%" name="documentissuer" v-validate="'required'"
									data-vv-as="document Issuer">
									<el-option v-for="tfCountry in countries" :key="tfCountry.name" :label="tfCountry.name"
										:value="tfCountry.name">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('documentissuer') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Document Issued On</span>
								<el-date-picker style="width: 100%" v-model="transFastPayoutRequest.idDateOfIssue"
									type="date" :picker-options="{ disabledDate: disableAllDatesAfterToday }"
									value-format="yyyy-MM-dd" placeholder="Document Issued On" name="doi"
									v-validate="'required'" data-vv-as="document expiry date">
								</el-date-picker>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('doi') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Document Expires On</span>
								<el-date-picker style="width: 100%" v-model="transFastPayoutRequest.idExpirationDate"
									type="date" :picker-options="{ disabledDate: disableAllDatesBeforeToday }"
									value-format="yyyy-MM-dd" placeholder="Document Expires On">
								</el-date-picker>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="12">
								<span>Date of birth</span>
								<el-date-picker style="width: 100%"
									:picker-options="{ disabledDate: disableLessThan18Dates }"
									v-model="transFastPayoutRequest.receiverDoB" type="date" value-format="yyyy-MM-dd"
									placeholder="Date of Birth" name="dob" v-validate="'required'"
									data-vv-as="date of birth">
								</el-date-picker>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('dob') }}</span>
								</transition>
							</el-col>
							<el-col :span="12">
								<span>Gender</span>
								<el-select v-model="transFastPayoutRequest.receiverGender" placeholder="Gender"
									style="width:100%">
									<el-option v-for="gender in genders" :key="gender.id" :label="gender.name"
										:value="gender.id">
									</el-option>
								</el-select>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="12">
								<span>Receiver's Phone Number</span>
								<el-input placeholder="Receiver's Phone Number"
									v-model="transFastPayoutRequest.receiverPhoneHome" name="receiverphonenumber"
									v-validate="'required'" data-vv-as="receiver's phone number"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receiverphonenumber') }}</span>
								</transition>
							</el-col>
							<el-col :span="12">
								<span>Receiver's Address</span>
								<el-input placeholder="Receiver's Address" v-model="transFastPayoutRequest.receiverAddress"
									name="receiveraddress" v-validate="'required'"
									data-vv-as="receiver's address"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receiveraddress') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="12">
								<span>Receiver's Occupation</span>
								<el-select v-model="transFastPayoutRequest.receiverOccupationId"
									placeholder="Receiver's Occupation" style="width:100%" name="receiveroccupation"
									v-validate="'required'" data-vv-as="receiver's occupation">
									<el-option v-for="tfOccupation in transfastReceiverOccupations" :key="tfOccupation.id"
										:label="tfOccupation.name" :value="tfOccupation.id">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('receiveroccupation') }}</span>
								</transition>
							</el-col>
							<el-col :span="12">
								<span>Reason for remittance</span>
								<el-select v-model="transFastPayoutRequest.remittanceReasonId"
									placeholder="Reason for remittance" style="width:100%" name="remittancereason"
									v-validate="'required'" data-vv-as="remittance reason">
									<el-option v-for="tfremittancereason in transfastRemittanceReasons"
										:key="tfremittancereason.id" :label="tfremittancereason.name"
										:value="tfremittancereason.id">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('remittancereason') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="12">
								<el-checkbox class="bg-warning w-100 pl-5"
									v-model="transFastPayoutRequest.proofOfAddressCollected">
									Proof of address has been collected
								</el-checkbox>
							</el-col>
							<el-col :span="12">
								<el-checkbox class="bg-warning w-100 pl-5" v-model="transFastPayoutRequest.kYCVerified">
									KYC has been verified
								</el-checkbox>
							</el-col>
						</el-row>
					</div>
					<div v-else>
						<el-row :gutter="20">
							<el-col :span="8">
								<span>Transaction Reference</span>
								<el-input placeholder="Transaction Reference" v-model="selectedTransaction.referenceNumber"
									:readonly="true"></el-input>
							</el-col>
							<el-col :span="8">
								<span>Receiver's Document Type</span>
								<el-select v-model="selectedTransaction.receiverDocumentTypeID"
									placeholder="Receiver's Document Type" class="mb-10" style="width:100%"
									name="treceiverdocType" v-validate="'required'" data-vv-as="receiver's document type"
									@change="receiversDocumentTypeChanged">
									<el-option v-for="dType in senderdocumentTypes" :key="dType.id" :label="dType.name"
										:value="dType.id">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('treceiverdocType') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Document number</span>
								<el-input placeholder="Receiver's Document Number"
									v-model="selectedTransaction.receiverDocumentNumber" name="treceiverdocnumber"
									v-validate="'required'" data-vv-as="receiver's document number"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('treceiverdocnumber') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="8">
								<span>First Name</span>
								<el-input placeholder="Receiver's First Name"
									v-model="selectedTransaction.receiverFirstName" name="treceiverfirstname"
									v-validate="'required'" :readonly="true" data-vv-as="receiver's first name"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('treceiverfirstname') }}</span>
								</transition>
							</el-col>
							<el-col :span="8">
								<span>Middle Name</span>
								<el-input placeholder="Receiver's Middle Name" :readonly="true"
									v-model="selectedTransaction.receiverMiddleName"></el-input>
							</el-col>
							<el-col :span="8">
								<span>Last Name</span>
								<el-input placeholder="Receiver's Last Name" v-model="selectedTransaction.receiverLastName"
									:readonly="true"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('treceiverlastname') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-20">
							<el-col :span="8">
								<span>Document Place of Issue</span>
								<el-select v-model="selectedTransaction.receiverDocumentPlaceofIssueId"
									placeholder="Document Place of Issue" style="width:100%" name="tplaceofissue"
									v-validate="'required'" data-vv-as="document place of issue">
									<el-option v-for="ctry in countries" :key="ctry.id" :label="ctry.name" :value="ctry.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="8">
								<span>Document Issue Date</span>
								<el-date-picker style="width: 100%"
									:picker-options="{ disabledDate: disableAllDatesAfterToday }"
									v-model="selectedTransaction.receiverDocumentIssuedOn" type="date"
									value-format="yyyy-MM-dd" placeholder="Date of Birth">
								</el-date-picker>
							</el-col>
							<el-col :span="8">
								<span>Document Expiration Date</span>
								<el-date-picker style="width: 100%"
									:picker-options="{ disabledDate: disableAllDatesBeforeToday }"
									v-model="selectedTransaction.receiverDocumentExpiresOn" type="date"
									value-format="yyyy-MM-dd" placeholder="Date of Birth">
								</el-date-picker>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="12">
								<span>Date of birth</span>
								<el-date-picker style="width: 100%"
									:picker-options="{ disabledDate: disableLessThan18Dates }"
									v-model="selectedTransaction.receiverDOB" type="date" value-format="yyyy-MM-dd"
									placeholder="Date of Birth" name="tdob" v-validate="'required'"
									data-vv-as="date of birth">
								</el-date-picker>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('tdob') }}</span>
								</transition>
							</el-col>
							<el-col :span="12">
								<span>Gender</span>
								<el-select v-model="selectedTransaction.receiverGenderStr" placeholder="Gender"
									style="width:100%" name="tgender" v-validate="'required'"
									data-vv-as="receiver's gender">
									<el-option v-for="gender in genders" :key="gender.id" :label="gender.name"
										:value="gender.id">
									</el-option>
								</el-select>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('tgender') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="12">
								<span>Receiver's Phone Number</span>
								<el-input placeholder="Receiver's Mobile Number"
									v-model="selectedTransaction.receiverMobileNumber" name="treceiverphonenumber"
									v-validate="'required'" data-vv-as="receiver's mobile number"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('treceiverphonenumber') }}</span>
								</transition>
							</el-col>
							<el-col :span="12">
								<span>Receiver's Address</span>
								<el-input placeholder="Receiver's Address" v-model="selectedTransaction.receiverAddress"
									name="treceiveraddress" v-validate="'required'"
									data-vv-as="receiver's address"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('treceiveraddress') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="24">
								<span>Reason for remittance</span>
								<el-input placeholder="Reason for remittance" type="textarea" :rows="2"
									v-model="selectedTransaction.transactionReason" name="transactionpurpose"
									v-validate="'required'" data-vv-as="remittance reason"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('transactionpurpose') }}</span>
								</transition>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mb-10">
							<el-col :span="24">
								<el-checkbox class="bg-warning w-100 pl-5" v-model="selectedTransaction.kycChecked">
									KYC has been verified
								</el-checkbox>
							</el-col>
						</el-row>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button type="danger" @click="receiverInfoDialogVisible = false">Cancel</el-button>
						<el-button type="primary" @click="saveReceiverInformation">Update</el-button>
					</span>
				</div>
				<div v-else>
					<el-row :gutter="20" class="mb-20">
						<el-col :span="3">
							<span class="info-text font-weight-900 font-size-16">Status: </span>
						</el-col>
						<el-col :span="12">
							<span class="primary-text font-weight-900 font-size-16 p-5 b-rad-20"
								:class="statusBackground">{{ selectedTransaction.transactionStatusStr }}</span>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="mb-20" v-show="selectedTransaction.transactionStatusStr === 'Locked'">
						<el-col :span="24">
							<span class="danger-text font-weight-900 font-size-16 p-5">**
								[{{ selectedTransaction.holdCategoryName }}]: {{ selectedTransaction.holdReason }}</span>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="mb-20" v-show="selectedTransaction.transactionStatusStr === 'Cancelled'">
						<el-col :span="24">
							<span class="primary-danger text-danger font-weight-900 font-size-16 p-5">**
								[{{ selectedTransaction.cancelCategoryName }}]: {{ selectedTransaction.cancelReason
								}}</span>
						</el-col>
					</el-row>
					<el-collapse accordion class="mb-20">
						<el-collapse-item name="senderInfo">
							<template slot="title">
								<i class="passed el-icon-success"></i>
								<span class="overviewTitle"> sender: </span>
								<span class="info-text font-weight-900 font-size-16">{{ selectedTransaction.senderName }}
								</span>
								<i class="header-icon el-icon-info"></i>
							</template>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Email: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">{{ selectedTransaction.email
									}}</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Phone: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">{{ selectedTransaction.phoneNumber
									}}</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">DOB: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">{{ selectedTransaction.dobStr
									}}</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Gender: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">{{ selectedTransaction.genderStr
									}}</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">{{
										selectedTransaction.documentTypeName }}:
									</span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">{{
										selectedTransaction.documentNumber }}</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Source of Funds: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">{{
										selectedTransaction.senderSourceOfFunds }}</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Purpose of Remittance: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">{{
										selectedTransaction.senderPurposeOfRemittance }}</span>
								</el-col>
							</el-row>
						</el-collapse-item>
						<el-collapse-item name="receiverInfo">
							<template slot="title">
								<i class="failed el-icon-error" v-if="receiverInfoIncomplete"></i>
								<i class="passed el-icon-success" v-else></i>
								<span class="overviewTitle"> receiver: </span>
								<span class="info-text font-weight-900 font-size-16">{{ selectedTransaction.receiverName }}
								</span>
								<i class="header-icon el-icon-info"></i>
							</template>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Email: </span>
								</el-col>
								<el-col :span="12">
									<span class="font-weight-900 font-size-16"
										:class="{ 'info-text': !receiverEmailRequired, 'danger-text': receiverEmailRequired }">{{
											receiverEmail }}</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Phone: </span>
								</el-col>
								<el-col :span="12">
									<span class="font-weight-900 font-size-16"
										:class="{ 'info-text': !receiverPhoneNumberRequired, 'danger-text': receiverPhoneNumberRequired }">
										{{ receiverPhoneNumber }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">DOB: </span>
								</el-col>
								<el-col :span="12">
									<span class="font-weight-900 font-size-16"
										:class="{ 'info-text': !receiverDOBRequired, 'danger-text': receiverDOBRequired }">
										{{ receiverDOB }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Gender: </span>
								</el-col>
								<el-col :span="12">
									<span class="font-weight-900 font-size-16"
										:class="{ 'info-text': !receivergenderRequired, 'danger-text': receivergenderRequired }">
										{{ receiverGender }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="font-weight-900 font-size-16"
										:class="{ 'info-text': !receiverDocumentTypeRequired, 'danger-text': receiverDocumentTypeRequired }">
										{{ receiverDocumentType }}
									</span>
								</el-col>
								<el-col :span="12">
									<span class="font-weight-900 font-size-16"
										:class="{ 'info-text': !receiverDocumentNumberRequired, 'danger-text': receiverDocumentNumberRequired }">
										{{ receiverDocumentNumber }}
									</span>
								</el-col>
							</el-row>
						</el-collapse-item>
						<el-collapse-item name="amountInfo">
							<template slot="title">
								<i class="passed el-icon-success"></i>
								<span class="overviewTitle"> amount: </span>
								<span class="info-text font-weight-900 font-size-16">
									{{ selectedTransaction.receiverCurrencySymbol }} {{
										selectedTransaction.receiverAmountStr }}
								</span>
								<i class="header-icon el-icon-info"></i>
							</template>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Sent Amount: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.senderCurrencySymbol }}.
										{{ selectedTransaction.senderAmountStr }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Received Amount: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.receiverCurrencySymbol }}.
										{{ selectedTransaction.receiverAmountStr }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Exchange Rate: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.receiverCurrencySymbol }}. {{
											selectedTransaction.exchangeRate }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20" v-show="userPermissionsFilter.viewtransactiontariffamount">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Tariff Fee: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.senderCurrencySymbol }}. {{ selectedTransaction.tariffFeeStr
										}}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20" v-show="userPermissionsFilter.viewtransactiontaxamount">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Tax %: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.senderCurrencySymbol }}.
										{{ selectedTransaction.taxPercentageStr }}
									</span>
								</el-col>
							</el-row>
						</el-collapse-item>
						<el-collapse-item name="serviceInfo">
							<template slot="title">
								<i class="warning el-icon-warning"></i>
								<span class="overviewTitle"> service: </span>
								<span class="info-text font-weight-900 font-size-16">{{ selectedTransaction.serviceName }}
								</span>
								<i class="header-icon el-icon-info"></i>
							</template>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Service Provider: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.serviceProviderName }} Transfast
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Sender Country: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.countryName }}
									</span>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="6">
									<span class="info-text font-weight-900 font-size-16">Receiver Country: </span>
								</el-col>
								<el-col :span="12">
									<span class="info-text font-weight-900 font-size-16">
										{{ selectedTransaction.receiverCountryName }}
									</span>
								</el-col>
							</el-row>
						</el-collapse-item>
					</el-collapse>
					<span slot="footer" class="dialog-footer">
						<div v-if="receiverInfoIncomplete">
							<el-button type="danger" @click="receiverInfoDialogVisible = true">Update Receiver
								Info</el-button>
							<el-button type="success" @click="viewSenderInvoice">Print Sender Invoice</el-button>
						</div>
						<div v-else-if="isTransfastTransaction && !transFastPayoutRequest.requestSent">
							<el-button type="info" @click="receiverInfoDialogVisible = true">Update Receiver
								Info</el-button>
							<el-button type="primary" @click="handlePayoutTransfastInvoice"
								v-show="userPermissionsFilter.payouttransactions">Pay Out</el-button>
						</div>
						<div v-else-if="selectedTransaction.kycChecked">
							<el-button type="info" @click="receiverInfoDialogVisible = true"
								v-show="selectedTransaction.transactionStatusStr == 'Pending'">Update Receiver
								Info</el-button>

							<el-button type="primary" v-show="selectedTransaction.transactionStatusStr == 'Pending'
								&& userPermissionsFilter.payouttransactions" @click="openPayoutPrompt">Pay Out</el-button>

							<el-button type="danger" v-show="selectedTransaction.transactionStatusStr != 'Paid Out'
								&& selectedTransaction.transactionStatusStr != 'Cancelled'
								&& userPermissionsFilter.canceltransactions" @click="cancelTransactionClicked">Cancel</el-button>

							<el-button type="warning" v-show="selectedTransaction.transactionStatusStr === 'Pending'
								&& userPermissionsFilter.holdtransactions" @click="holdDialogFormVisible = true">Hold</el-button>

							<el-button type="info" v-show="selectedTransaction.transactionStatusStr === 'Locked'
								&& userPermissionsFilter.releasetransactions" @click="unLockCurrentTransaction">Release</el-button>

							<el-button type="success" v-show="selectedTransaction.transactionStatusStr === 'Cancelled'
								&& userPermissionsFilter.uncanceltransactions" @click="unCancellCurrentTransaction">Uncancel</el-button>

							<el-button type="success" v-show="selectedTransaction.transactionStatusStr === 'Paid Out'
								&& userPermissionsFilter.reversetransactions" @click="reverseCurrentTransaction">Reverse</el-button>

							<el-button type="success" v-show="selectedTransaction.transactionStatusStr === 'Paid Out'"
								@click="viewInvoice">Print Payout Invoice</el-button>

							<el-button type="success" @click="viewSenderInvoice">Print Sender Invoice</el-button>
						</div>
						<div v-else-if="printPayoutInvoice">
							<el-button v-show="showReverseTransfastTransaction && userPermissionsFilter.reversetransactions"
								type="warning" @click="handleReverseTransfastInvoice">Reverse Payment</el-button>
							<el-button type="success" @click="viewInvoice">Print Payout Invoice</el-button>
						</div>
					</span>
				</div>
			</el-dialog>

			<el-dialog title="Reason for holding transaction" :visible.sync="holdDialogFormVisible">
				<el-row :gutter="20">
					<el-col :span="12">
						<span>Reason Category</span>
						<el-select v-model="selectedTransaction.holdCategoryID" placeholder="Reason Category"
							style="width:100%" name="reasoncategory" v-validate="'required'" data-vv-as="reason category">
							<el-option v-for="cCategory in systemCategories" :key="cCategory.id" :label="cCategory.name"
								:value="cCategory.id">
							</el-option>
						</el-select>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('reasoncategory') }}</span>
						</transition>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mt-10">
					<el-col :span="24">
						<span>Description</span>
						<el-input placeholder="Description" type="textarea" :rows="3"
							v-model="selectedTransaction.holdReason" name="description" v-validate="'required'"
							data-vv-as="description"></el-input>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('description') }}</span>
						</transition>
					</el-col>
				</el-row>
				<span slot="footer" class="dialog-footer mt-10">
					<el-button @click="hideHoldDialog">Cancel</el-button>
					<el-button type="primary" @click="holdTransactionClicked">Confirm</el-button>
				</span>
			</el-dialog>

			<el-dialog title="Search Parameters" :visible.sync="searchFormVisible" @close="saveSearchParameters">
				<el-row :gutter="20">
					<el-col :span="8">
						<span>Sender Firstname</span>
						<el-input v-model="searchParameters.senderFirstName" placeholder="Sender Firstname"></el-input>
					</el-col>
					<el-col :span="8">
						<span>Sender Middlename</span>
						<el-input v-model="searchParameters.senderMiddleName" placeholder="Sender Middlename"></el-input>
					</el-col>
					<el-col :span="8">
						<span>Sender Lastname</span>
						<el-input v-model="searchParameters.senderLastName" placeholder="Sender Lastname"></el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mt-10">
					<el-col :span="8">
						<span>Receiver Firstname</span>
						<el-input v-model="searchParameters.receiverFirstName" placeholder="Receiver Firstname"></el-input>
					</el-col>
					<el-col :span="8">
						<span>Receiver Middlename</span>
						<el-input v-model="searchParameters.receiverMiddleName"
							placeholder="Receiver Middlename"></el-input>
					</el-col>
					<el-col :span="8">
						<span>Receiver Lastname</span>
						<el-input v-model="searchParameters.receiverLastName" placeholder="Receiver Lastname"></el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mt-10">
					<el-col :span="12">
						<span>Sender Gender</span>
						<el-select v-model="searchParameters.senderGender" filterable placeholder="Sender Gender"
							style="width:100%">
							<el-option v-for="gender in genders" :key="gender" :label="gender" :value="gender">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="12">
						<span>Receiver Gender</span>
						<el-select v-model="searchParameters.receiverGender" filterable placeholder="Receiver Gender"
							style="width:100%">
							<el-option v-for="gender in genders" :key="gender" :label="gender" :value="gender">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mt-10">
					<el-col :span="12">
						<span>Sender Country</span>
						<el-select v-model="searchParameters.senderCountry" filterable placeholder="Sender Country"
							style="width:100%">
							<el-option v-for="country in countries" :key="country.id" :label="country.name"
								:value="country.id">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="12">
						<span>Receiver Country</span>
						<el-select v-model="searchParameters.receiverCountry" filterable placeholder="Receiver Country"
							style="width:100%">
							<el-option v-for="country in countries" :key="country.id" :label="country.name"
								:value="country.id">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mt-10">
					<el-col :span="12">
						<span>Service Type</span>
						<el-select v-model="searchParameters.serviceType" filterable placeholder="Service Type"
							style="width:100%">
							<el-option v-for="servicetype in serviceTypes" :key="servicetype.id" :label="servicetype.name"
								:value="servicetype.id">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="12">
						<span>Service Provider</span>
						<el-select v-model="searchParameters.serviceProvider" filterable placeholder="Service Provider"
							style="width:100%">
							<el-option v-for="sp in companyNames" :key="sp.id" :label="sp.name" :value="sp.id">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mt-10">
					<el-col :span="12">
						<span>From Date</span>
						<el-date-picker style="width: 100%" v-model="searchParameters.fromDate" type="date"
							format="yyyy-MM-dd" placeholder="From Date">
						</el-date-picker>
					</el-col>
					<el-col :span="12">
						<span>To Date</span>
						<el-date-picker style="width: 100%" v-model="searchParameters.toDate" type="date"
							format="yyyy-MM-dd" placeholder="To Date">
						</el-date-picker>
					</el-col>
				</el-row>
				<span slot="footer" class="dialog-footer">
					<el-button type="info" @click="clearSearchParameters">Clear All</el-button>
					<el-button type="primary" @click="saveSearchParameters">Confirm</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/'
import { bus } from '@/main'
import { Validator } from 'vee-validate'

export default {
	name: 'Transactions',
	data() {
		return {
			searchFormVisible: false,
			dialogVisible: false,
			showDelete: false,
			overviewUpdated: false,
			receiverEmailRequired: true,
			receiverPhoneNumberRequired: true,
			receiverDOBRequired: true,
			receivergenderRequired: true,
			receiverDocumentTypeRequired: true,
			receiverDocumentNumberRequired: true,
			updateReceiverInfo: false,
			receiverInfoDialogVisible: false,
			genders: [{ id: 'M', name: 'Male' }, { id: 'F', name: 'Female' }],
			selectedTransaction: {},
			isUpdatingTransfastReceipient: false,
			transactionReceiverInfoIncomplete: false,
			updatingTransfastReceipientText: '',
			refreshStatusTimer: '',
			printPayoutInvoice: false,
			holdDialogFormVisible: false,
			cancelDialogFormVisible: false,
			systemCategories: '',
			transFastPayoutRequest: {
				tfPin: '',
				idNumber: '',
				idType: '',
				idExpirationDate: '',
				idDateOfIssue: '',
				idIssuedBy: '',
				idPlaceofIssue: '',
				receiverAddress: '',
				receiverOccupationId: '',
				remittanceReasonId: '',
				receiverCountryIsoCode: '',
				receiverStateId: '',
				receiverCityId: '',
				receiverPhoneHome: '',
				receiverDoB: '',
				receiverNationalityIsoCode: '',
				receiverGender: '',
				receiverRelationToSender: '',
				formOfPaymentId: '',
				proofOfAddressCollected: false,
				kYCVerified: false
			},
			searchParameters: {
				page: 1,
				size: 20,
				searchByReference: false,
				referenceNumber: '',
				senderFirstName: '',
				senderMiddleName: '',
				senderLastName: '',
				receiverFirstName: '',
				receiverMiddleName: '',
				receiverLastName: '',
				senderGender: '',
				receiverGender: '',
				receiverCountry: '',
				senderCountry: '',
				serviceType: '',
				serviceProvider: '',
				fromDate: '',
				toDate: '',
				paidOutBy: '',
				paidOutFromDate: '',
				paidOutToDate: '',
				compliance: true
			},
			genders: ['Male', 'Female'],
			statuses: ['', ''],
			companyTypes: [{ type: 'Agent', name: 'Agent' }, { type: 'Partner', name: 'Partner' },
			{ type: 'Branch', name: 'Branch' }],
		}
	},
	computed: {
		showReverseTransfastTransaction() {
			if (this.transFastPayoutRequest && this.selectedTransaction) {
				var date = new Date(this.transFastPayoutRequest.sentOn);
				date.setHours(date.getHours() + 2);

				return (this.transFastPayoutRequest.requestSent
					&& this.selectedTransaction.transfastInvoiceID > 0
					&& date >= new Date())
			}

			return false;
		},
		receiverEmail() {
			//var email = "**RECEIVER'S EMAIL REQUIRED**";
			// this.receiverEmailRequired = true;
			// if((this.selectedTransaction.receiverEmail &&
			//  this.selectedTransaction.receiverEmail.length > 0) ||
			//  this.selectedTransaction.transfastInvoiceID > 0){
			// 	this.receiverEmailRequired = false;
			// 	email= this.selectedTransaction.receiverEmail;
			// }
			// return email;

			this.receiverEmailRequired = false;
			return this.selectedTransaction.receiverEmail;
		},
		receiverPhoneNumber() {
			var phoneNumber = "**RECEIVER'S PHONE REQUIRED**";
			this.receiverPhoneNumberRequired = true;
			if (this.isTransfastTransaction && this.selectedTransaction.receiverPhoneNumber &&
				this.selectedTransaction.receiverPhoneNumber.length > 0) {
				this.receiverPhoneNumberRequired = false;
				phoneNumber = this.selectedTransaction.receiverPhoneNumber;
			}
			else if (this.selectedTransaction.receiverMobileNumber &&
				this.selectedTransaction.receiverMobileNumber.length > 0) {
				this.receiverPhoneNumberRequired = false;
				phoneNumber = this.selectedTransaction.receiverMobileNumber;
			}
			return phoneNumber;
		},
		receiverDOB() {
			var dob = "**RECEIVER'S DOB REQUIRED**";
			this.receiverDOBRequired = true;
			if (this.selectedTransaction.receiverDOBStr &&
				this.selectedTransaction.receiverDOBStr.length > 0) {
				this.receiverDOBRequired = false;
				dob = this.selectedTransaction.receiverDOBStr;
			}
			return dob;
		},
		receiverGender() {
			var gender = "**RECEIVER'S GENDER REQUIRED**";
			this.receivergenderRequired = true;
			if (this.selectedTransaction.receiverGenderStr &&
				this.selectedTransaction.receiverGenderStr.length > 0) {
				this.receivergenderRequired = false;
				gender = this.selectedTransaction.receiverGenderStr;
			}
			return gender;
		},
		receiverDocumentType() {
			var docType = "**RECEIVER'S DOCUMENT TYPE REQUIRED**"
			this.receiverDocumentTypeRequired = true;
			if (this.selectedTransaction.receiverDocumentTypeName &&
				this.selectedTransaction.receiverDocumentTypeName.length > 0) {
				this.receiverDocumentTypeRequired = false;
				docType = this.selectedTransaction.receiverDocumentTypeName + ':';
			}
			return docType;
		},
		receiverDocumentNumber() {
			var docNumber = "**RECEIVER'S DOCUMENT NUMBER REQUIRED**"
			this.receiverDocumentNumberRequired = true;
			if (this.selectedTransaction.receiverDocumentNumber &&
				this.selectedTransaction.receiverDocumentNumber.length > 0) {
				this.receiverDocumentNumberRequired = false;
				docNumber = this.selectedTransaction.receiverDocumentNumber;
			}
			return docNumber;
		},
		receiverInfoIncomplete() {
			if (this.isTransfastTransaction)
				return (this.transactionReceiverInfoIncomplete);
			else {
				return !(this.selectedTransaction.kycChecked);
			}
		},
		statusBackground() {
			switch (this.selectedTransaction.transactionStatusStr) {
				case 'Pending': return 'bg-accent';
				case 'Cancelled': return 'bg-danger';
				case 'Paid Out': return 'bg-success';
				default: return 'bg-info';
			}
		},
		dialogTitle() {
			var receiverName = this.selectedTransaction.receiverName ? this.selectedTransaction.receiverName.toLowerCase() : '';
			var serviceName = this.selectedTransaction.serviceName ? this.selectedTransaction.serviceName.toLowerCase() : '';
			var senderName = this.selectedTransaction.senderName ? this.selectedTransaction.senderName.toLowerCase() : '';
			if (this.receiverInfoDialogVisible) {
				return 'update ' + receiverName + "'s " + ' information';
			}
			else {
				return receiverName + "'s " + serviceName
					+ ' from ' + senderName;
			}
		},
		isTransfastTransaction() {
			return (this.selectedTransaction.transfastInvoiceID && this.selectedTransaction.transfastInvoiceID > 0);
		},
		receiverInfoUptoDate() {
			return (this.receiverPhoneNumberRequired
				|| this.receiverDOBRequired
				|| this.receivergenderRequired || this.receiverDocumentTypeRequired
				|| this.receiverDocumentNumberRequired);
		}
	},
	methods: {
		downloadData() {
			this.setSearchParameters();
			this.getTransactions(this.searchParameters)
				.then(result => {
					if (result.items)
						this.downloadCSV(result.items.map(p => {
							var c = {
								Reference_Number: p.referenceNumber,
								Sender: p.senderName,
								Receiver: p.receiverName,
								Transaction_Status: p.transactionStatusStr,
								Receiver_Currency: p.receiverCurrencySymbol,
								Receiver_Amount: p.receiverAmountStr,
								Service_Type: p.serviceName,
								Service_Provider: p.serviceProviderName,
								Sender_Country: p.countryName,
								Receiver_Country: p.receiverCountryName,
								CreatedOn: p.createdOnStr
							};

							return c;
						}));
				})
				.catch(err => this.errorMessage('Error downloading data.'));
		},
		clearSearchParameters() {
			this.searchParameters = {
				page: 1,
				size: 20,
				searchByReference: false,
				referenceNumber: '',
				senderFirstName: '',
				senderMiddleName: '',
				senderLastName: '',
				receiverFirstName: '',
				receiverMiddleName: '',
				receiverLastName: '',
				senderGender: '',
				receiverGender: '',
				receiverCountry: '',
				senderCountry: '',
				serviceType: '',
				serviceProvider: '',
				fromDate: '',
				toDate: '',
				paidOutBy: '',
				paidOutFromDate: '',
				paidOutToDate: '',
				compliance: true
			};
		},
		saveSearchParameters() {
			this.searchFormVisible = false;
			this.searchParameters.searchByReference = false;
			this.searchParameters.referenceNumber = '';
			this.refreshTransactions();
		},
		searchTransaction() {
			this.searchFormVisible = false;
			this.searchParameters.searchByReference = true;
			this.refreshTransactions();
		},
		print(row) {
			this.startLoader("Loading Page...");
			var self = this;
			this.findTransactionByID(row.id)
				.then(trans => {
					this.stopLoader();
					this.selectedTransaction = trans;
					this.dialogVisible = true;
					this.requestValid = false;
					this.printPayoutInvoice = this.selectedTransaction.transactionStatusStr === 'Paid Out';
					if (this.isTransfastTransaction) {
						this.getTransfastPaymentRequest(trans.referenceNumber)
							.then(result => {
								if (result) {
									self.getTransfastStates(result.receiverCountryIsoCode);
									this.getTransfastCities(result.receiverCountryIsoCode, result.receiverStateId);
									self.getTransfastReceiverIdType(result.receiverCountryIsoCode);
									self.getTransfastRemittanceReasons(result.receiverCountryIsoCode);
									if (result.idType == 0) result.idType = '';
									if (result.receiverOccupationId == 0) result.receiverOccupationId = '';
									if (result.remittanceReasonId == 0) result.remittanceReasonId = '';
									if (result.receiverCityId == 0) result.idType = '';
									if (result.idType == 0) result.idType = '';
									if (result.idType == 0) result.idType = '';



									self.transFastPayoutRequest = result;
									if (self.transFastPayoutRequest.idIssuedBy === null)
										self.transFastPayoutRequest.idIssuedBy = this.getCountryName(result.receiverCountryIsoCode);

									self.requestValid = result.requestValid;
									self.transactionReceiverInfoIncomplete = !result.requestValid;
								}
							}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
					}
					else {
						this.transactionReceiverInfoIncomplete = this.receiverInfoUptoDate;
						if (this.selectedTransaction.receiverDocumentTypeID == 0)
							this.selectedTransaction.receiverDocumentTypeID = '';

						var doc = this.getDocumentType(this.selectedTransaction.receiverDocumentTypeName);

						if (doc)
							this.selectedTransaction.receiverDocumentTypeID = doc.id;
					}
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		createTransaction() {
			router.push('/addtransaction');
		},
		deleteSelectedTransactions() {

		},
		refreshTransactions() {
			this.startLoader("Loading Transactions ...");
			this.setSearchParameters();
			this.getTransactions(this.searchParameters)
				.then(result => {
					this.tableRefreshed(result);
					this.stopLoader();
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		setSearchParameters() {
			this.searchParameters.page = this.currentPage;
			this.searchParameters.size = this.paginationInfo.pageSize;
			this.searchParameters.compliance = true;
		},
		transactionAddedCallback() {
			this.refreshTransactions();
		},
		transactionUpdatedCallback(id, refNo, user) {

			if (this.dialogVisible &&
				this.selectedTransaction.id == id) {
				this.warningMessage(`Transaction #${refNo} has been updated by ${user}`);
				this.print(this.selectedTransaction);
			}
		},
		getRowClassName({ row, rowIndex }) {
			var status = row.transactionStatusStr;
			if (status === 'Cancelled' || status === 'Locked') {
				return 'danger-row';
			} else if (status === 'Paid Out') {
				return 'success-row';
			}
			return '';
		},
		handleClose(done) {
			if (this.receiverInfoDialogVisible) {
				this.$confirm('Close processing this transaction?')
					.then(_ => {
						this.receiverInfoDialogVisible = false;
						done();
					})
					.catch(_ => { });
			}
			else {
				done();
			}
		},
		handlePayoutTransfastInvoice() {
			this.$confirm('Do you wish to proceed with paying out this transaction?')
				.then(_ => {
					this.activateLoader(`processing transaction...`, true);
					//this.processingActive();
					this.payoutTransfastInvoice();
				})
				.catch(_ => {
				});
		},
		handleReverseTransfastInvoice() {
			this.$confirm('Are you sure to reverse this transaction?')
				.then(_ => {
					this.activateLoader(`processing transaction...`, true);
					//this.processingActive();
					this.reverseTransfastInvoice();
				})
				.catch(_ => {
				});
		},
		activateLoader(text, state) {
			this.updatingTransfastReceipientText = text;
			this.isUpdatingTransfastReceipient = state;
		},
		clearDialogState() {
			this.transFastPayoutRequest = {
				tfPin: '',
				idNumber: '',
				idType: '',
				idExpirationDate: '',
				idDateOfIssue: '',
				idIssuedBy: '',
				idPlaceofIssue: '',
				receiverAddress: '',
				receiverOccupationId: '',
				remittanceReasonId: '',
				receiverCountryIsoCode: '',
				receiverStateId: '',
				receiverCityId: '',
				receiverPhoneHome: '',
				receiverDoB: '',
				receiverNationalityIsoCode: '',
				receiverRelationToSender: '',
				formOfPaymentId: '',
				proofOfAddressCollected: false,
				kYCVerified: false
			};
			this.transactionReceiverInfoIncomplete = false;
			this.activateLoader('', false);
			this.clearReceiverInfo();
			this.receiverEmailRequired = false;
			this.receiverPhoneNumberRequired = false;
			this.receiverDOBRequired = false;
			this.receivergenderRequired = false;
			this.receiverDocumentNumberRequired = false;
			this.updateReceiverInfo = false;
			this.overviewUpdated = false;
			this.receiverInfoDialogVisible = false;
			this.selectedTransaction = '';
		},
		saveReceiverInformation() {
			if (this.isTransfastTransaction) {
				this.$validator.validateAll()
					.then(result => {
						if (!this.$validator.errors.has('receivercountry') && !this.$validator.errors.has('receiverstate')
							&& !this.$validator.errors.has('receivercity') && !this.$validator.errors.has('tfpin')
							&& !this.$validator.errors.has('receiverdocType') && !this.$validator.errors.has('receiverdocnumber')
							&& !this.$validator.errors.has('documentissuer') && !this.$validator.errors.has('receiverphonenumber')
							&& !this.$validator.errors.has('dob') && !this.$validator.errors.has('doi')
							&& !this.$validator.errors.has('receiveraddress') && !this.$validator.errors.has('receiveroccupation')
							&& !this.$validator.errors.has('remittancereason')) {
							var self = this;
							this.activateLoader(`please wait while we update ${this.selectedTransaction.receiverName}'s info...`, true);
							this.transFastPayoutRequest.tfPin = this.selectedTransaction.referenceNumber;
							this.transFastPayoutRequest.ReceiverNationalityIsoCode = this.transFastPayoutRequest.receiverCountryIsoCode;
							this.transFastPayoutRequest.idTypeStringReplacement = this.transFastPayoutRequest.idType.toString();
							this.transFastPayoutRequest.idPlaceofIssue = this.transFastPayoutRequest.idIssuedBy;

							var doc = this.getTransfastDocumentType(this.transFastPayoutRequest.idType);

							if (doc) {
								this.transFastPayoutRequest.idTypeCode = doc.name;
								this.transFastPayoutRequest.idTypeName = doc.name;
							}

							this.updateTransfastReceiverInfo(this.transFastPayoutRequest)
								.then(response => {
									this.receiverInfoDialogVisible = !response;
									if (!response) {
										self.errorMessage(`Failed to update ${this.selectedTransaction.receiverName}'s info`);
									}
									else {
										self.fireUpdateEvent();
										self.successMessage(`Sucessfully to update ${this.selectedTransaction.receiverName}'s info`);
									}

									self.activateLoader('', false);
									self.clearReceiverInfoChecks(response);
									self.receiverInfoDialogVisible = !response;
								})
								.catch(err => {
									self.errorMessage(`Failed to update ${this.selectedTransaction.receiverName}'s info`);
									this.activateLoader('', false);
								});
						}
						else {
							self.errorMessage(`Failed to update ${this.selectedTransaction.receiverName}'s info`);
							this.activateLoader('', false);
						}
					});
			} else {
				this.$validator.validateAll()
					.then(result => {
						if (!this.$validator.errors.has('ttfpin') && !this.$validator.errors.has('treceiverdocType')
							&& !this.$validator.errors.has('treceiverdocnumber') && !this.$validator.errors.has('tdob')
							&& !this.$validator.errors.has('tgender') && !this.$validator.errors.has('treceiverphonenumber')
							&& !this.$validator.errors.has('treceiveraddress') && !this.$validator.errors.has('transactionpurpose')) {
							if (!this.selectedTransaction.kycChecked) {
								this.infoMessage('Check KYC verified to proceed.');
							}
							else {
								this.updateTransactionReceiverInfo(this.selectedTransaction)
									.then(response => {
										this.selectedTransaction = response;
										if (response.id > 0) {
											this.receiverInfoDialogVisible = !response;
											if (!response) {
												self.errorMessage(`Failed to update ${this.selectedTransaction.receiverName}'s info`);
											}
											else {
												self.fireUpdateEvent();
												self.successMessage(`Sucessfully to update ${this.selectedTransaction.receiverName}'s info`);
											}

											self.activateLoader('', false);
											self.clearReceiverInfoChecks(response);
											self.receiverInfoDialogVisible = !response;
										}
									})
									.catch(err => {
										self.errorMessage(`Failed to update ${this.selectedTransaction.receiverName}'s info`);
										this.activateLoader('', false);
									});
							}
						}
						else {
							self.errorMessage(`Failed to update ${this.selectedTransaction.receiverName}'s info`);
							this.activateLoader('', false);
						}
					});
			}

		},
		fireUpdateEvent() {
			if (this.selectedTransaction)
				this.transactionUpdatedEvent(this.selectedTransaction);
		},
		clearReceiverInfoChecks(incomplete) {
			this.transactionReceiverInfoIncomplete = !incomplete;
			this.receiverEmailRequired = !incomplete;
			this.receiverPhoneNumberRequired = !incomplete;
			this.receiverDOBRequired = !incomplete;
			this.receivergenderRequired = !incomplete;
			this.receiverDocumentTypeRequired = !incomplete;
			this.receiverDocumentNumberRequired = !incomplete;
		},
		payoutTransfastInvoice() {
			this.payoutTransfastTransaction(this.selectedTransaction.referenceNumber)
				.then(result => {
					this.activateLoader('', false);
					//this.doneActive();
					if (result.isSuccess) {
						this.fireUpdateEvent();
						this.selectedTransaction.transactionStatusStr = 'Paid Out';
						this.printPayoutInvoice = true;
						this.transFastPayoutRequest.requestSent = true;
						this.successMessage('Transaction has been paid out successfully.');
					}
					else {
						this.printPayoutInvoice = false;
						this.transFastPayoutRequest.requestSent = false;
						this.errorMessage(result.completeMessage);
					}
					this.isUpdatingTransfastReceipient = false;
				})
				.catch(err => {
					this.activateLoader('', false);
					this.isUpdatingTransfastReceipient = false;
					this.printPayoutInvoice = false;
					this.transFastPayoutRequest.requestSent = false;
					this.errorMessage('Something went wrong. Try again in a bit.');
				});
		},
		reverseTransfastInvoice() {
			this.reverseTransfastTransaction(this.selectedTransaction.referenceNumber)
				.then(result => {
					this.activateLoader('', false);
					if (result.isSuccess) {
						this.fireUpdateEvent();
						this.printPayoutInvoice = false;
						this.selectedTransaction.transactionStatusStr = 'Pending';
						this.transFastPayoutRequest.requestSent = false;
						this.successMessage('Transaction has been reversed successfully.');
					}
					else {
						this.printPayoutInvoice = true;
						this.transFastPayoutRequest.requestSent = true;
						this.errorMessage(result.completeMessage);
					}
				})
				.catch(err => {
					this.activateLoader('', false);
					this.printPayoutInvoice = true;
					this.transFastPayoutRequest.requestSent = true;
					this.errorMessage('Something went wrong. Try again in a bit.');
				});
		},
		payoutCurrentTransaction() {
			this.isUpdatingTransfastReceipient = true;
			this.activateLoader('Processing transaction...', true);
			this.pageLoading = true;
			this.payOutTransaction(this.selectedTransaction.id)
				.then(result => {
					this.pageLoading = false;
					this.isUpdatingTransfastReceipient = false;
					//this.doneActive();
					this.activateLoader('', false);
					if (result.success) {
						this.successMessageBox(result.message, 'Transaction Paided Out');
						this.fireUpdateEvent();
						this.refreshSelectedTransaction();
						this.transactionAddedEvent(this.selectedTransaction);
					}
					else
						this.errorMessageBox(result.message, 'Payout Failed');
				})
				.catch((err) => {
					this.pageLoading = false; this.isUpdatingTransfastReceipient = false
				});
		},
		receiversDocumentTypeChanged(e) {
			this.senderdocumentTypes.forEach(p => {
				if (p.id == e)
					this.selectedTransaction.receiverDocumentTypeName = p.name;
			});
		},
		cancelCurrentTransaction() {
			this.isUpdatingTransfastReceipient = false;
			//this.processingActive();
			this.activateLoader('Processing transaction...', true);
			this.cancelTransaction(this.selectedTransaction)
				.then(result => {
					this.isUpdatingTransfastReceipient = false;
					//this.doneActive();
					this.activateLoader('', false);
					if (result) {
						this.successMessage('Transaction has been cancelled.');
						this.fireUpdateEvent();
						this.refreshSelectedTransaction();
					}
					else
						this.errorMessage('Failed to cancel transaction.');
				})
				.catch(() => this.isUpdatingTransfastReceipient = false);
		},
		cancelTransactionClicked() {
			this.holdDialogFormVisible = true;
			this.cancelDialogFormVisible = true;
		},
		hideHoldDialog() {
			this.holdDialogFormVisible = false;
			this.cancelDialogFormVisible = false;
		},
		holdTransactionClicked() {
			this.$validator.validateAll()
				.then(result => {
					if (!this.$validator.errors.has('reasoncategory') && !this.$validator.errors.has('description')) {
						if (this.cancelDialogFormVisible) {
							this.openCancelPrompt();
						}
						else if (this.holdDialogFormVisible) {
							this.openHoldPrompt();
						}
					};
				});
		},
		openPayoutPrompt() {
			this.$confirm('Do you wish to pay out this transaction?', 'Warning', {
				confirmButtonText: 'Proceed',
				cancelButtonText: 'Cancel',
				type: 'warning'
			}).then(() => {
				this.payoutCurrentTransaction();
			}).catch(() => {
			});
		},
		openHoldPrompt() {
			this.$confirm('This transaction will be locked, and can only be unlocked by the proper rights. Do you wish to proceed?', 'Warning', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'warning'
			}).then(() => {
				this.holdDialogFormVisible = false;
				this.cancelDialogFormVisible = false;
				this.lockCurrentTransaction();
			}).catch(() => {
				this.holdDialogFormVisible = false;
				this.cancelDialogFormVisible = false;
				this.$message({
					type: 'info',
					message: 'Transaction lock canceled'
				});
			});
		},
		openCancelPrompt() {
			this.$confirm('This transaction will be cancelled, and can only be uncancelled by the proper rights. Do you wish to proceed?', 'Warning', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'warning'
			}).then(() => {
				this.holdDialogFormVisible = false;
				this.cancelDialogFormVisible = false;
				this.cancelCurrentTransaction();
			}).catch(() => {
				this.holdDialogFormVisible = false;
				this.cancelDialogFormVisible = false;
				this.$message({
					type: 'info',
					message: 'Transaction not canceled'
				});
			});
		},
		lockCurrentTransaction() {
			this.isUpdatingTransfastReceipient = false;
			//this.processingActive();
			this.activateLoader('Locking transaction...', true);
			this.holdTransaction(this.selectedTransaction)
				.then(result => {
					this.isUpdatingTransfastReceipient = false;
					//this.doneActive();
					this.activateLoader('', false);
					if (result) {
						this.successMessage('Transaction has been locked.');
						this.fireUpdateEvent();
						this.refreshSelectedTransaction();
					}
					else
						this.errorMessage('Failed to lock transaction.');
				})
				.catch(() => {
					this.isUpdatingTransfastReceipient = false;
				});
		},
		unLockCurrentTransaction() {
			this.isUpdatingTransfastReceipient = false;
			//this.processingActive();
			this.activateLoader('Unlocking transaction...', true);
			this.releaseTransaction(this.selectedTransaction.id)
				.then(result => {
					this.isUpdatingTransfastReceipient = false;
					//this.doneActive();
					this.activateLoader('', false);
					if (result) {
						this.successMessage('Transaction has been unlocked.');
						this.fireUpdateEvent();
						this.refreshSelectedTransaction();
					}
					else
						this.errorMessage('Failed to release transaction.');
				})
				.catch(() => this.isUpdatingTransfastReceipient = false);
		},
		unCancellCurrentTransaction() {
			this.isUpdatingTransfastReceipient = false;
			//this.processingActive();
			this.activateLoader('Uncancelling transaction...', true);
			this.unCancelTransaction(this.selectedTransaction.id)
				.then(result => {
					this.isUpdatingTransfastReceipient = false;
					//this.doneActive();
					this.activateLoader('', false);
					if (result) {
						this.successMessage('Transaction has been uncancelled.');
						this.fireUpdateEvent();
						this.refreshSelectedTransaction();
					}
					else
						this.errorMessage('Transaction reactivation failed.');
				})
				.catch(() => this.isUpdatingTransfastReceipient = false);
		},
		reverseCurrentTransaction() {
			this.isUpdatingTransfastReceipient = false;
			//this.processingActive();
			this.activateLoader('Reversing transaction...', true);
			this.reverseTransaction(this.selectedTransaction.id)
				.then(result => {
					this.isUpdatingTransfastReceipient = false;
					//this.doneActive();
					this.activateLoader('', false);
					if (result) {
						this.successMessage('Transaction has been reversed successfully.');
						this.fireUpdateEvent();
						this.refreshSelectedTransaction();
					}
					else
						this.errorMessage('Transaction reverse failed.');
				})
				.catch(() => this.isUpdatingTransfastReceipient = false);
		},
		refreshSelectedTransaction() {
			this.findTransactionByID(this.selectedTransaction.id)
				.then(result => {
					this.selectedTransaction = result;
					this.silentRefreshTransactions();
				});
		},
		silentRefreshTransactions() {
			this.setSearchParameters();
			this.getTransactions(this.searchParameters)
				.then(result => {
					this.tableRefreshed(result);
				})
				.catch(err => {
					this.tableRefreshed(this.defaultListResult);
				});
		},
		viewInvoice() {
			router.push(`transactioninvoice/${this.selectedTransaction.id}`);
		},
		viewSenderInvoice() {
			router.push(`senderinvoice/${this.selectedTransaction.id}`);
		},
		tfCountryChanged() {
			this.clearReceiverInfo();
			this.getTransfastStates(this.transFastPayoutRequest.receiverCountryIsoCode);
			this.getTransfastReceiverIdType(this.transFastPayoutRequest.receiverCountryIsoCode);
			this.getTransfastRemittanceReasons(this.transFastPayoutRequest.receiverCountryIsoCode);
			if (this.transFastPayoutRequest.idIssuedBy === null)
				this.transFastPayoutRequest.idIssuedBy = this.getCountryName(this.transFastPayoutRequest.receiverCountryIsoCode);
		},
		tfStateChanged() {
			this.transfastCities = [];
			this.transFastPayoutRequest.receiverCityId = '';
			this.getTransfastCities(this.transFastPayoutRequest.receiverCountryIsoCode,
				this.transFastPayoutRequest.receiverStateId);
		},
		clearReceiverInfo() {
			this.transfastStates = [];
			this.transfastCities = [];
			this.transfastReceiverIdTypes = [];
			this.transfastRemittanceReasons = [];

			this.transFastPayoutRequest.remittanceReasonId = '';
			this.transFastPayoutRequest.receiverStateId = '';
			this.transFastPayoutRequest.receiverCityId = '';
			this.transFastPayoutRequest.receiverNationalityIsoCode = '';
			this.transFastPayoutRequest.formOfPaymentId = '';
		},
		clearTransfastReceipientvalidator() {
			this.$validator.errors.clear();
		},
		getCountryName(countryCode) {
			var name = '';
			this.countries.forEach(element => {
				if (element.code === countryCode)
					name = element.name;
			});
			return name;
		},
		getTransfastDocumentType(idType) {
			var idDoc = '';
			this.transfastReceiverIdTypes.forEach(element => {
				if (element.id === idType)
					idDoc = element;
			});
			return idDoc;
		},
		getDocumentType(idName) {
			var idDoc = '';
			this.senderdocumentTypes.forEach(element => {
				if (element.name === idName)
					idDoc = element;
			});
			return idDoc;
		},
		getSenderDocuments(e) {
			let doctypesbody = {
				CountryID: e,
				Type: "Sender",
				CustomerType: "Individual",
				PaymentService: "C2C",
				ServiceTypeID: 1,
			}
			this.getSenderDocumentTypes(doctypesbody);
		},
		processingActive() {
			this.processActiveEvent('Transaction is been proccessed');
		},
		doneActive() {
			this.doneActiveEvent('Transaction has been proceed');
		},
		processingEventCallback(message) {
			//this.activateLoader(message, true);
		},
		doneEventCallback(message) {
			//this.activateLoader('', false);
		},
		refreshTransfastInvoiceStatus() {
			if (!this.refreshStatusTimer) { // it seems to me this additional check would make sense?
				this.refreshStatusTimer = setInterval(() => {
					if (this.dialogVisible && this.selectedTransaction.transfastInvoiceID > 0) {
						this.getTransfastInvoiceStatus(this.selectedTransaction.referenceNumber)
							.then(result => {
								var status = '';
								switch (result.toLowerCase()) {
									case 'notpaid':
										this.printPayoutInvoice = false;
										this.transFastPayoutRequest.requestSent = false;
										status = 'Pending';
										break;
									case 'ok':
									case 'paid':
										this.printPayoutInvoice = true;
										this.transFastPayoutRequest.requestSent = true;
										status = 'Paid Out';
										break;
								}

								if (this.selectedTransaction.transactionStatusStr !== status) {
									this.selectedTransaction.transactionStatusStr = status;
									//update status in server
								}
							})
							.catch(err => {
								console.log(err);
							});
					}
				}, 5000)
			} else {
				clearInterval(this.refreshStatusTimer)
			}
		}
	},
	created() {
		this.transactionConnection.start().catch(err => console.error(err.toString()));
		this.commonConnection.start().catch(err => console.error(err.toString()));
		this.addedEvent = 'transactionAddedCallback';
		this.updatedEvent = 'transactionUpdatedCallback';
		this.deleteEvent = 'deleteSelectedTransactions';
		this.refreshListEvent = 'refreshTransactions';
		this.processingEvent = 'processingEventCallback';
		this.doneEvent = 'doneEventCallback';
		this.$on(this.addedEvent, this.transactionAddedCallback);
		this.$on(this.updatedEvent, this.transactionUpdatedCallback);
		this.$on(this.refreshListEvent, this.refreshTransactions);
		this.$on(this.deleteEvent, this.deleteSelectedTransactions);
		this.$on(this.processingEvent, this.processingEventCallback);
		this.$on(this.doneEvent, this.doneEventCallback);
		this.updatePaginationText();
		this.getTransfastCountries();
		this.getSenderDocuments(212);
		this.getTransfastReceiverOccupations();

		this.getCountries();
		this.getCurrencies();
		this.getFundingTypes();
		this.getServices();
		this.getCompanyNames();
	},
	mounted() {
		this.clearDialogState();
		this.refreshStatusTimer = '';
		this.refreshTransfastInvoiceStatus();
		this.refreshTransactions();
		this.getSystemCategory({ all: true, systemCategoryContext: 'Transactions' })
			.then(result => {
				let items = [];
				if (result)
					this.systemCategories = result.items;
				else
					this.systemCategories = '';
			});
	},
	beforeRouteUpdate(to) {
		console.log('router updated...');
	},
	mixins: [PermissionsMixins]
}
</script>

<style lang="scss" scoped>
.upesi .page-table {
	&.overflow {
		overflow: auto;
	}

	.table-box {
		overflow: hidden;
	}
}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';

.upesi {
	.page-table {
		.custom-action-row {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

			.el-button {
				padding: 1px 5px;
			}
		}

		.toolbar-box {
			margin-top: 20px;

			.search-box {
				&>div {
					width: 20px;
					display: inline-block;
				}

				margin-bottom: 10px;

				i {
					display: inline-block;
					width: 22px;
				}

				input {
					outline: none;
					background: transparent;
					border: none;
					font-size: 15px;
					position: relative;
					padding: 0;
					margin-left: -20px;
					display: inline-block;
					padding-left: 20px;
					box-sizing: border-box;
					top: -1px;
					width: 100%;
					color: $text-color;
				}

				.icons-tot {
					margin-right: 20px;
				}
			}

			.pagination-box {
				width: 120px;
				margin: 0 15px;

				.select-box {
					width: 70px;
					display: inline-block;
				}

				.label {
					width: 50px;
					display: inline-block;
				}

				.el-input__inner {
					height: 22px;
					border: none;
					background: transparent;
					font-size: 16px;
					text-align: right;
					font-family: inherit;
					padding-right: 20px;
					color: $text-color;
				}

				.el-input__suffix {
					right: -3px;

					.el-select__caret {
						color: transparentize($text-color, 0.7);
					}
				}
			}

			a,
			button {
				padding: 0;
				margin: 0 15px;
				background: transparent;
				border: none;
				outline: none;
				font-family: inherit;
				font-size: inherit;
				cursor: pointer;

				border-bottom: 1px solid;
				text-decoration: none;
				color: $text-color;

				&:hover {
					opacity: .6;
				}
			}

			a {
				margin-right: 0;
			}
		}

		.sel-string {
			.sel {
				background: transparentize($text-color, 0.8);
				border-radius: 5px;
				text-transform: uppercase;
			}
		}
	}

	@media (max-width: 768px) {
		.page-table {
			.toolbar-box {
				display: block;
				overflow: hidden;
				font-size: 80%;

				&>* {
					display: inline-block;
					min-width: 120px;
					height: 22px;
					background: rgba(0, 0, 0, 0.04);
					padding: 4px;
					margin: 3px !important;
				}
			}
		}
	}

	.overviewTitle {
		font-weight: bold;
		color: green;
		text-transform: uppercase;
	}

	.passed {
		color: green;
	}

	.failed {
		color: red;
	}

	.warning {
		color: orange;
	}

	.overviewInfoTitle {
		font-weight: bold;
	}
}</style>
